import { AnalyticsBrowser as s } from "./index6.js";
const a = "SegmentHandler not initialized. Call init() first.";
class i {
  static #t;
  analytics;
  constructor() {
    this.analytics = null;
  }
  static get instance() {
    return i.#t || (i.#t = new i()), i.#t;
  }
  init(t) {
    this.analytics || (this.analytics = s.load({ writeKey: t }));
  }
  async track(...t) {
    if (!this.analytics) throw new Error(a);
    return await this.analytics.track(...t);
  }
  async page(...t) {
    if (!this.analytics) throw new Error(a);
    return await this.analytics.page(...t);
  }
  async identify(...t) {
    if (!this.analytics) throw new Error(a);
    return await this.analytics.identify(...t);
  }
}
export {
  i as SegmentHandler
};
//# sourceMappingURL=index2.js.map
